export enum SavingFilterStatus {
  Success = 0,
  FilterNameDuplicate = 7,
}
